import React from 'react';
import EmptyState from './EmptyState';

const DataTable = ({ children, className = '' }) => (
  <div className={`bg-white dark:bg-dark-800 rounded-2xl shadow-card border border-gray-100 dark:border-dark-700 overflow-hidden ${className}`}>
    <div className="overflow-x-auto">
      {children}
    </div>
  </div>
);

export const TableHead = ({ columns }) => (
  <thead>
    <tr className="bg-gradient-to-r from-primary-600 to-primary-700 text-white">
      {columns.map((col, i) => (
        <th
          key={i}
          className={`px-4 py-4 text-left text-sm font-semibold ${col.className || ''}`}
        >
          {col.label}
        </th>
      ))}
    </tr>
  </thead>
);

export const TableBody = ({ children }) => (
  <tbody className="divide-y divide-gray-100 dark:divide-dark-700">
    {children}
  </tbody>
);

export const TableRow = ({ children, className = '', onClick }) => (
  <tr
    onClick={onClick}
    className={`hover:bg-gray-50 dark:hover:bg-dark-700 transition-colors ${onClick ? 'cursor-pointer' : ''} ${className}`}
  >
    {children}
  </tr>
);

export const TableCell = ({ children, className = '' }) => (
  <td className={`px-4 py-3 text-sm text-gray-600 dark:text-gray-300 ${className}`}>
    {children}
  </td>
);

export const TableEmpty = ({ colSpan, preset = 'search', title, description, icon }) => (
  <tr>
    <td colSpan={colSpan} className="p-0">
      <EmptyState preset={preset} title={title} description={description} icon={icon} compact />
    </td>
  </tr>
);

export default DataTable;
